import React from "react";
import "../screen/signup.css";

export default class Course extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      matric: false,
      inter: false,
      graduate: false,
      master: false,
    };
  }
  render() {
    return (
      <>
        
      </>
    );
  }
}
